import type { DefaultTheme } from 'styled-components';
import { lightColors, mapLightTheme, talosLightButtons } from './LightTheme';

export const LightTalosTheme: DefaultTheme = mapLightTheme(lightColors, {
  name: 'LightDefault',
  ...talosLightButtons,

  spacingLayout: 2,
});
